<script>
  import { selectedLanguage } from "../etc/store.js"
</script>

<footer class="page-footer indigo ">
  <div class="container">
    <div class="row">
      <!-- <div class="col l4 s12">
        <h5 class="white-text"><a href="/books">古籍</a></h5>
        <p class="grey-text text-lighten-4">
          古今中外，有關易經的書籍非常多。在【XiYi
          習易網】裡，目前我只放了最基本的周易、十翼原始經文和朱熹的卦序歌。
        </p>
      </div> -->
      <!-- <div class="col l6 s12">
        <h5 class="white-text">
          <a href="/about"
            >{$selectedLanguage == "TW"
              ? "關於 【XiYi 習易網】"
              : "关于 【XiYi 习易网】"}</a
          >
        </h5>
        <p class="grey-text text-lighten-4">
          {$selectedLanguage == "TW"
            ? "【XiYi 習易網】是一個提供學習易網經的人平常讀易、玩易、起占、解卦、紀錄及分享卦例的方便所在。核心價值：省時、省力、隨時、隨地。不再需要韋編三絕。"
            : "【XiYi 习易网】是一个提供学习易网经的人平常读易、玩易、起占、解卦、纪录及分享卦例的方便所在。核心价值：省时、省力、随时、随地。不再需要韦编三绝。"}
        </p>
      </div>
      <div class="col l6 s12">
        <h5 class="white-text">
          <a
            href={$selectedLanguage == "TW"
              ? "mailto:ixiyi88@gmail.com?subject=【XiYi 習易網】：訪客意見"
              : "mailto:ixiyi88@gmail.com?subject=【XiYi 习易网】：访客意见"}
            >{$selectedLanguage == "TW" ? "聯絡" : "联络"}</a
          >
        </h5>
        <p class="grey-text text-lighten-4">
          {$selectedLanguage == "TW"
            ? "有需要的話，請寄email到："
            : "有需要的话，请寄email到："}
          <a
            href={$selectedLanguage == "TW"
              ? "mailto:ixiyi88@gmail.com?subject=【XiYi 習易網】：訪客意見"
              : "mailto:ixiyi88@gmail.com?subject=【XiYi 习易网】：访客意见"}
            ><u>ixiyi88@gmail.com</u></a
          >。
        </p>
      </div> -->
    </div>
  </div>
  <div class="footer-copyright">
    <div class="container">
      © 2024 All rights reserved. {$selectedLanguage == "TW"
        ? "【XiYi 習易網】"
        : "【XiYi 习易网】"} 
    </div>
  </div>
</footer>

<style>
  a {
    color: white;
  }
</style>
